import appConstants from '../constants';

export default async function fetchService(
  serviceName,
  serviceURL,
  serviceInit,
  hasCustomResponseData = false
) {
  let serviceResponse = {
    data: {},
    success: true,
    statusMessage: ''
  };
  try {
    // Send http request to endpoint.
    const response = await fetch(serviceURL, serviceInit);

    // verify response status
    if (!response.ok && (response.status !== 202)) {
      const message = `An error has occurred: ${response.statusText}`;
      throw new Error(message);
    }

    // Verify response content type.
    const responseContentType = response.headers.get(appConstants.HEADER_CONTENT_TYPE);
    if (!responseContentType || !responseContentType.includes(appConstants.CONTENT_TYPE_APPLICATION_JSON)) {
      throw new TypeError(appConstants.SERVICE_ERROR_INVALID_RESPONSE_CONTENT_TYPE);
    }


    // convert data to json.
    const data = await response.json();

    // verify structure/attributes of the response json object.
    if(!hasCustomResponseData) {
      if (
        (undefined === data?.success) ||
        ((data?.success === true) && (undefined === data?.data)) ||
        ((data?.success === false) && ((undefined === data?.statusMessage) || (undefined === data?.message )))
      ) {
        const message = appConstants.SERVICE_ERROR_INVALID_RESPONSE_MISSING_ATTRIBUTE;
        throw new Error(message);
      }
      // store response json object.
      serviceResponse = data;

      // fix response shape.
      if ((data?.message !== undefined) && (data?.statusMessage !== undefined)) {
        serviceResponse.statusMessage = serviceResponse.message;
        delete serviceResponse.message;
      }
    }
    else {
      serviceResponse.data = data;
    }

  }
  catch (exception) {
    console.error(`${serviceName} >> ${exception.message}`);
    serviceResponse.success = false;
    serviceResponse.statusMessage = `${serviceName} >> ${exception.message}`;
  }
  finally {
    return serviceResponse;
  }
}
